import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NoticiaTipo } from '../../../../typesSite/noticia/NoticiaTipo';
import { ISnoticia, Noticia } from '../../../../typesSite/noticia/Noticia';

const initialState = ISnoticia;

const publicacaoSlice = createSlice({
  name: 'publicacao',
  initialState,
  reducers: {
    // Reducer para atualizar o título da notícia

    atualizarTipo: (state, action: PayloadAction<NoticiaTipo>) => {
      state.tipo = action.payload;
    },
    atualizarCapa: (state, action: PayloadAction<boolean>) => {
      state.capa = action.payload;
    },
    atualizarTitulo: (state, action: PayloadAction<string>) => {
      state.titulo = action.payload;
    },

    // Reducer para atualizar o subtítulo da notícia
    atualizarSubtitulo: (state, action: PayloadAction<string>) => {
      state.subtitulo = action.payload;
    },

    // Reducer para atualizar o resumo da notícia
    atualizarResumo: (state, action: PayloadAction<string>) => {
      state.resumo = action.payload;
    },
    atualizarImagemCapa: (state, action: PayloadAction<string>) => {
      state.imagem = action.payload;
    },

    // Reducer para atualizar o corpo da notícia
    atualizarCorpo: (state, action: PayloadAction<string>) => {
      state.corpo = action.payload;
    },

    atualizarDataHoraLiberacao: (state, action: PayloadAction<Date | null>) => {
      if (action.payload) {
        state.dataHoraLiberacao = action.payload.toString(); // converte o Date para string
      } else {
        state.dataHoraLiberacao = '';
      }
    }, // Atualiza a data e hora de liberação da notícia

    // Reducer para atualizar a data e hora de criação da notícia

    // Reducer para marcar a notícia como pública
    marcarComoPublica: (state, action: PayloadAction<boolean>) => {
      state.is_publica = action.payload;
    },

    resetarEstado: () => initialState,
    setPublicacao: (state, action: PayloadAction<Noticia>) => {
      return { ...state, ...action.payload }; // Atualiza o estado com os dados recebidos
    }
  }
});

export const {
  atualizarTitulo,
  atualizarSubtitulo,
  atualizarResumo,
  atualizarCorpo,
  atualizarTipo,
  marcarComoPublica,
  atualizarImagemCapa,
  atualizarCapa,
  atualizarDataHoraLiberacao,
  resetarEstado,
  setPublicacao
} = publicacaoSlice.actions;

export default publicacaoSlice.reducer;
